module.exports = __webpack_public_path__ + "img/1.ffad2afd.jpg";